/* tslint:disable */
 
import { FileModel } from './file-model';
import { LocalizedValue } from './localized-value';
export class LanguageEntryValue {
  code: string;
  direction?: string;
  flag: string;
  id?: string;
  isDefault: boolean;
  mobile_translation_file?: null | FileModel;
  name: LocalizedValue;
  web_translation_files?: null | FileModel;
}
